import { app } from '../app.module'
/**
 * ユーザデータに関するService
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function UserData(Restangular, $q) {
  /**
   * 対象ユーザの情報を取得
   * @param {number} userId ユーザId
   * @return {Object} ユーザ情報
   */
  function getUser(userId: number) {
    const getUrl = `/users/getUserById?userId=${userId}`
    const deferred = $q.defer()

    // 設定したユーザIDでユーザ情報を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  /**
   * パスワード再設定のハッシュをチェック
   * @param {string} hash ハッシュ
   * @return {Object} 結果
   */
  function checkHash(hash) {
    const deferred = $q.defer()

    Restangular.all('/users/checkHash?hash=' + hash)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  /**
   * パスワード再設定のハッシュを生成
   * @param {string} email メール
   * @return {Object} 結果
   */
  function createPassResetHash(email) {
    const deferred = $q.defer()

    Restangular.all('/users/createPassResetHash')
      .post({ email: email })
      .then((result) => {
        deferred.resolve(result.data)
      })

    return deferred.promise
  }

  /**
   * パスワード再設定
   * @param {string} password パスワード
   * @param {string} userId ユーザーID
   * @return {Object} 結果
   */
  function resetPassword(password, userId) {
    const deferred = $q.defer()
    const resetInfo = {
      password: password,
      userId: userId,
    }

    Restangular.all('/users/resetPassword')
      .post(resetInfo)
      .then((result) => {
        deferred.resolve(result.data)
      })

    return deferred.promise
  }

  return {
    getUser: getUser,
    checkHash: checkHash,
    createPassResetHash: createPassResetHash,
    resetPassword: resetPassword,
  }
}

/**
 * グループデータに関するService
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function GroupData(Restangular, $q) {
  /**
   * グループ一覧を取得
   * @return {array} グループ一覧
   */
  function getGroupLists() {
    const getUrl = '/group/groups'
    const deferred = $q.defer()

    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  return {
    getGroupLists: getGroupLists,
  }
}

/**
 * UserService ユーザ情報管理関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} UserData ユーザデータに関するService
 * @param {Function} GroupData グループデータに関するService
 * @return {Object} サービスのオブジェクト
 */
function UserService(UserData, GroupData) {
  return {
    User: UserData,
    Group: GroupData,
  }
}

// サービスを定義
app
  .factory('UserService', UserService)
  .factory('UserData', UserData)
  .factory('GroupData', GroupData)
